export function stringComparator<T>(callback: (c: T) => string): (a: T, b: T) => number {
  return (a: T, b: T) => {
    const aValue = callback(a);
    const bValue = callback(b);
    return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
  };
}
